<template>
  <div class="el-section">
    <div
      class="emd-container _highlight_header _header_spaced _footer_spaced_sm"
    >
      <div class="emd-container__header">
        <h2 class="emd-text _size_section">{{ $t('trf.title') }}</h2>
        <button
          class="emd-btn _color_primary _size_small jsModalOpen"
          v-on:click="openModal('custom')"
          v-if="permissionIsEnabled('trf.report:create')"
          id="btn-open-modal-trf"
        >
          <i class="uil uil-plus" />
          {{ $t('trf.new-trf') }}
        </button>
      </div>
      <div
        v-if="loadingList"
        class="eu-pa_6 eu-align_center"
      >
        <div class="emd-loader _invert">
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
      <div
        class="emd-table-responsive"
        v-if="!loadingList"
      >
        <table class="emd-table">
          <thead>
            <tr>
              <th>{{ $t('trf.name') }}</th>
              <th>{{ $t('trf.date') }}</th>
              <th>{{ $t('trf.size') }}</th>
              <th v-if="permissionIsEnabled('trf.report:export')"></th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(trf, index) in trfs.items"
              :key="index"
            >
              <td :data-label="$t('trf.name')">{{ trf.name }}</td>
              <td :data-label="$t('trf.date')">
                {{ trf.date | dateFormat('date') }}
              </td>
              <td :data-label="$t('trf.size')">{{ trf.size }}</td>
              <td
                :data-label="$t('trf.download')"
                class="eu-align_right"
                v-if="permissionIsEnabled('trf.report:export')"
              >
                <a
                  :href="$sanitize(trf.url)"
                  class="emd-btn-ghost btn-download-trf"
                  :title="$t('trf.download')"
                  rel="noopener noreferrer"
                  @click="track"
                >
                  <i class="uil uil-arrow-to-bottom"></i>
                </a>
                <!-- <button class="emd-btn-ghost" :title="$t('trf.download')" v-on:click="generateNamedTRF(trf.name)">
                  <i class="uil uil-arrow-to-bottom"></i>
                </button> -->
              </td>
            </tr>
          </tbody>
        </table>
        <empty-list
          class="eu-pb_3"
          v-if="!loadingList && trfs.pagination.total_items === 0"
          entity="trf"
        ></empty-list>
      </div>
    </div>

    <Modal :open="modalOpenned">
      <template slot="content">
        <div
          class="emd-container _highlight_header _footer_end _footer_spaced_mobile"
        >
          <div class="emd-container__header">
            <h2 class="emd-text _size_section">
              {{ $t('trf.modal.title') }}
            </h2>
            <button
              class="emd-btn _type_link jsModalClose"
              type="button"
              v-on:click="closeModal()"
              v-if="!loadingTRF"
            >
              <i class="uil uil-times" />
            </button>
          </div>
          <form
            @submit="generateCustomTRF"
            name="formTRF"
            novalidate="true"
          >
            <div
              class="emd-container__content"
              v-if="loadingTRF"
            >
              <emd-alert
                variant="warning"
                v-if="loadingTRF"
                @cancel="loadingTRF = false"
                :title="$t('trf.modal.alert-loading-title')"
              >
                <template slot="content">
                  {{ $t('trf.modal.alert-loading') }}
                </template>
              </emd-alert>

              <div class="emd-loader _invert eu-align_center eu-pa_3">
                <div></div>
                <div></div>
                <div></div>
              </div>
            </div>
            <div class="emd-container__content">
              <emd-alert
                :variant="variantAlert"
                v-if="showAlert"
                @cancel="showAlert = false"
                :title="
                  formError
                    ? $t('account.settings.alert.error-title')
                    : $t('account.settings.alert.success-title')
                "
              >
                <template slot="content">
                  <div v-if="formError">
                    <p
                      v-for="(error, index) in errors"
                      :key="index"
                    >
                      {{ error }}
                    </p>
                  </div>
                  <p v-else>{{ $t('account.settings.saved-success') }}</p>
                </template>
              </emd-alert>

              <div
                class="el-section"
                v-if="!loadingTRF && trfType === 'custom'"
              >
                <div class="eu-flex eu-column eu-row_sm">
                  <div class="eu-flex-item eu-basis_6_sm">
                    <div
                      class="emd-form-group"
                      :class="{ _state_error: interval.startDate.error }"
                    >
                      <label
                        class="emd-label _required"
                        for="startDate"
                        >{{ $t('trf.modal.start-date') }}</label
                      >
                      <input-date
                        id="startDate"
                        :value="interval.startDate.value"
                        :locale="locale"
                        @input="setDate($event, 'startDate')"
                      />
                    </div>
                  </div>
                  <div class="eu-flex-item eu-basis_6_sm">
                    <div
                      class="emd-form-group"
                      :class="{ _state_error: interval.endDate.error }"
                    >
                      <label
                        class="emd-label _required"
                        for="endDate"
                        >{{ $t('trf.modal.end-date') }}</label
                      >
                      <input-date
                        id="endDate"
                        :value="interval.endDate.value"
                        :locale="locale"
                        @input="setDate($event, 'endDate')"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="emd-container__footer"
              v-if="!loadingTRF && trfType === 'custom'"
            >
              <button
                class="emd-btn _color_primary _type_text"
                type="button"
                v-on:click="closeModal()"
              >
                {{ $t('trf.modal.cancel') }}
              </button>
              <button
                class="emd-btn _color_primary"
                type="submit"
                id="btn-generate-trf"
                @click="track"
              >
                {{ $t('trf.modal.generate') }}
              </button>
            </div>
          </form>
        </div>
      </template>
    </Modal>
  </div>
</template>
<script>
import Modal from '@/components/project/globals/Modal.vue'
import EmptyList from '@/components/project/globals/EmptyList.vue'
import { EmdAlert } from 'emerald-vue/src/components'
import InputDate from '@/components/project/atoms/InputDate.vue'

export default {
  components: {
    Modal,
    EmptyList,
    InputDate,
    EmdAlert
  },
  data () {
    return {
      optionsOpenned: false,
      modalOpenned: false,
      loadingList: true,
      loadingTRF: false,
      trfType: null,
      interval: {
        startDate: {
          value: null,
          error: false
        },
        endDate: {
          value: null,
          error: false
        }
      },
      trfs: [],
      errors: [],
      typeError: null,
      debounceTimer: undefined,
      showAlert: false,
      formError: false
    }
  },
  computed: {
    locale () {
      return this.$store.getters.pref.language
    },
    merchant: function () {
      return this.$store.getters.merchant
    },
    account: function () {
      return this.$store.getters.account
    },
    variantAlert () {
      if (this.typeError === 'error' || this.typeError === 'catchErrorAPI')
        return 'danger'
      else return 'warning'
    }
  },
  methods: {
    track: function () {
      if (this.$gtag) {
        this.$gtag.event('click', {
          event_category: 'trfButton',
          event_label: `${this.$store.getters.profile.user.email} (${this.$store.getters.merchant.id}/${this.$store.getters.account.id})`
        })
      }
    },
    toggleOptions: function () {
      this.optionsOpenned = !this.optionsOpenned
    },
    openModal: function (type) {
      this.modalOpenned = true
      this.trfType = type
    },
    closeModal: function () {
      this.interval.startDate.value = null
      this.interval.startDate.error = false
      this.interval.endDate.value = null
      this.interval.endDate.error = false
      this.modalOpenned = false
      this.errors = []
      this.typeError = null
    },
    closeAlert: function () {
      this.errors = []
      this.typeError = null
    },
    setDate (date, key) {
      this.interval[key].value = date
      this.interval[key].error = false
    },
    validDate (date, key) {
      if (date === null || date === undefined || date === '') {
        this.interval[key].error = true
      } else {
        if (date.length === 10) {
          const value = new Date(date)
          if (isNaN(value.getTime()) || value.getTime() < 0) {
            this.interval[key].error = true
          } else {
            this.interval[key].error = false
          }
        } else {
          this.interval[key].error = true
        }
      }
      this.$set(this.interval, key, this.interval[key])
      return !this.interval[key].error
    },
    createTRF: function (body) {
      this.loadingTRF = true
      var filename = body.name
      this.errors = []
      if (body.type === 'custom') {
        delete body.name
      }
      const params = {
        merchantId: this.merchant.id,
        accountId: this.account.id,
        body: body
      }
      this.showAlert = false
      const msgErrorInternal = this.$t('trf.modal.error-internal')
      this.$store
        .dispatch('CREATE_TRF', params)
        .then(res => {
          const blob = new Blob([res], { type: 'text/csv;charset=utf-8;' })
          const url = URL.createObjectURL(blob)
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(blob, filename)
          } else {
            const linkElement = document.createElement('a')
            linkElement.setAttribute('href', url)
            linkElement.setAttribute('download', filename)
            const clickEvent = new MouseEvent('click', {
              view: window,
              bubbles: true,
              cancelable: false
            })
            linkElement.dispatchEvent(clickEvent)
          }
          this.closeModal()
          this.loadingTRF = false
        })
        .catch(err => {
          this.loadingTRF = false
          this.showAlert = true
          this.formError = true
          if (err.body && Array.isArray(err.body.errors)) {
            this.typeError = 'catchErrorAPI'
            err.body.errors.forEach(error => {
              if (!this.errors.includes(error.message)) {
                this.errors.push(error.message)
              }
            })
          } else {
            this.typeError = 'error'
            this.errors.push(msgErrorInternal)
          }
        })
    },
    // generateNamedTRF: function (name) {
    //   this.trfType = 'by_name'
    //   this.openModal(this.trfType)
    //   this.createTRF({ type: this.trfType, name: name })
    // },
    generateCustomTRF: function (e) {
      e.preventDefault()
      const validDates =
        this.validDate(this.interval.startDate.value, 'startDate') &&
        this.validDate(this.interval.endDate.value, 'endDate')
      if (validDates) {
        this.errors = []
        const start = new Date(`${this.interval.startDate.value}T00:00:00Z`)
        const end = new Date(`${this.interval.endDate.value}T23:59:59Z`)
        const totalDays = end.getTime() - start.getTime()
        const startAt = start.toISOString()
        const endAt = end.toISOString()
        if (totalDays < 0) {
          this.typeError = 'alert'
          this.formError = true
          this.showAlert = true
          this.errors = [this.$t('trf.modal.alert-minor-date')]
        } else if (totalDays >= 0 && totalDays <= 2678400000) {
          const name = `transactionreportfile_${this.interval.startDate.value}_${this.interval.endDate.value}.csv`
          const body = {
            type: this.trfType,
            name: name,
            start_at: startAt,
            end_at: endAt
          }
          this.createTRF(body)
        } else if (totalDays > 2678400000) {
          this.typeError = 'alert'
          this.formError = true
          this.showAlert = true
          this.errors = [this.$t('trf.modal.alert-larger-date')]
        }
        clearTimeout(this.debounceTimer)
        this.debounceTimer = setTimeout(() => {
          this.errors = []
          this.formError = false
          this.typeError = null
        }, 7000)
      }
    },
    permissionIsEnabled (action) {
      return this.$store.getters.permissionIsEnabled(action)
    }
  },
  beforeMount: function () {
    const params = { merchantId: this.merchant.id, accountId: this.account.id }
    this.$store.dispatch('GET_TRFS', params).then(res => {
      this.trfs = res
      this.loadingList = false
    })
  },
  mounted () {
    document.addEventListener(
      'mouseup',
      e => {
        const toggleOptions = document.getElementById('toggleOptions')
        if (toggleOptions && !toggleOptions.contains(e.target)) {
          this.optionsOpenned = false
        }
      },
      { passive: true }
    )
  }
}
</script>
